module.exports = __webpack_public_path__ + "img/index-comp-pic1.5ae79899.png";